import { Loading } from "@components/common/Loading";
import RecruiterForm from "@components/ui/recruiter/components/recruiter-form";
import ProfileHeader from "@components/ui/profile/profileHeader";
import { useGetFormBuilderAccessToken } from "@hooks/useGetFormBuilderAccessToken";
import { Box, Container, Grid } from "@mui/material";
import { getUserRelatedFromBuilder } from "@services/api/authentication/get-user-related-from-builder/getUserRelatedFromBuilder";
import { useAuth } from "@services/authentication/auth.context";
import { enqueueSnackbar } from "notistack";
import { useEffect, useState } from "react";
import { useLanguage } from "../../contexts/LanguageContext";
import translations from "./translations.json";
type SupportedLanguage = keyof typeof translations;

const ProfilePage = () => {

    const { user } = useAuth();
    const { language } = useLanguage();
    const content = translations[language as SupportedLanguage] || translations.en;

    const { loading: loadingFormBuilderAccessToken, formBuilderAccessToken } = useGetFormBuilderAccessToken(["recruiter"]);

    const [loading, setLoading] = useState<boolean>(true);
    const [userRelatedData, setUserRelatedData] = useState(null);

    useEffect(() => {
        const handleFetchUserRelatedBuilder = async () => {
            setLoading(true);
            if (user?.userFormUUID) {
                try {
                    const userRelated = await getUserRelatedFromBuilder({ uuid: user.userFormUUID });
                    setUserRelatedData(userRelated?.data?.['hydra:member']?.[0]?.props || null);
                } catch (error) {
                    console.error('Error fetching user related data from builder:', error);
                }
            }
            setLoading(false);
        }
        handleFetchUserRelatedBuilder();
    }, [user?.id]);

    const handleAfterSubmit = () => {
        enqueueSnackbar(content.success, { variant: 'success' });
        setTimeout(() => {
            window.location.reload(); // Refresh the page to reflect updated profile information
        }, 1000); // Optional: Delay to allow the user to see the success message
        
    };


    return <Box sx={{ minHeight: '100vh', py: 6 }}>
                <Container maxWidth="xl">
                    {/* Header section */}
                    <ProfileHeader />
                    
                    {/* Grid de Cards */}
                    <Grid 
                        container 
                        spacing={3} 
                        sx={{ mt: 1 }} 
                        justifyContent="center"
                    >
                        {(loadingFormBuilderAccessToken || loading) && (
                            <Grid item xs={12} display="flex" justifyContent="center">
                                <Loading />
                            </Grid>
                        )}
                        {!loadingFormBuilderAccessToken && !loading && userRelatedData && (
                            <Grid item xs={12} md={10} lg={8}>
                                {user?.role == 'recruiter' && (
                                    
                                    <RecruiterForm 
                                        key={formBuilderAccessToken} 
                                        defaultValue={userRelatedData}
                                        onAfterSubmit={handleAfterSubmit}
                                        formBuilderAccessToken={formBuilderAccessToken} 
                                    />
                                )}
                            </Grid>
                        )}
                        {!loading && !userRelatedData && (
                            <Grid item xs={12} display="flex" justifyContent="center">
                                <Box sx={{ color: '#999', fontSize: '1.2rem' }}>
                                    {content.empty}
                                </Box>
                            </Grid>
                        )}
                    </Grid>
                </Container>
            </Box>
}

export default ProfilePage;